import { useEffect } from "react";
import { Constants } from "../utils/Constants";

const ChatWootWidget = ({ me }) => {
  useEffect(() => {
    const scriptId = "chatwoot-script";

    const updateChatwootUser = () => {
      if (window.$chatwoot && me) {
        const name = `${me.identity?.usu_name} da ${me.identity?.empresa?.emp_nome_fantasia}`;
        window.$chatwoot.setUser(me.identity?.usu_id_empresa, {
          name,
          email: me.user?.email,
        });
        window.$chatwoot.setCustomAttributes({
          nome: name,
          cnpj: me.identity?.empresa?.emp_cnpj,
        });
        window.$chatwoot.setConversationCustomAttributes({
          nome: name,
          cnpj: me.identity?.empresa?.emp_cnpj,
        });
      }
    };

    const onChatwootReady = () => {
      updateChatwootUser();
    };

    window.addEventListener("chatwoot:ready", onChatwootReady);

    if (window.$chatwoot) {
      updateChatwootUser();
    }

    window.chatwootSettings = {
      hideMessageBubble: false,
      position: "right",
      locale: "pt_BR",
      type: "standard",
    };

    if (!document.getElementById(scriptId)) {
      (function(d, t) {
        var g = d.createElement(t),
          s = d.getElementsByTagName(t)[0];
        g.src = Constants.chatWootBaseUrl + "/packs/js/sdk.js";
        g.id = scriptId;
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: Constants.chatWootWebsiteToken,
            baseUrl: Constants.chatWootBaseUrl,
          });
        };
      })(document, "script");
    } else if (window.$chatwoot) {
      window.$chatwoot.toggleBubbleVisibility("show");
    }

    return () => {
      window.removeEventListener("chatwoot:ready", onChatwootReady);
      if (window.$chatwoot) {
        window.$chatwoot.reset();
        window.$chatwoot.toggleBubbleVisibility("hide");
      }
    };
  }, [me]);

  return null;
};

export default ChatWootWidget;
